import { render, staticRenderFns } from "./WorksheetNote.vue?vue&type=template&id=783ba3f8"
import script from "./WorksheetNote.vue?vue&type=script&lang=js"
export * from "./WorksheetNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports